import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatDate } from "../../Helper/Helper";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import Spinner from "../Spinner";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function SecondBlogsGrid() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [blogsData, setBlogsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getBlogsData();
  }, []);

  const getBlogsData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("blogs/list");
      setBlogsData(response?.data);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Blogs" Image="theme-2-banner-blog.webp"/>

        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "300px" }}
          >
            <Spinner />
          </div>
        ) : blogsData?.length > 0 ? (
          <section className="blog-section pad-top-80 pad-bottom-80 full-dark">
            <div className="container">
              <div className="row">
                <div className="offset-md-2 col-md-8">
                  <div className="title-wrap text-center">
                    <div className="section-title margin-bottom-60">
                      <h2 className="section-title mb-0 text-uppercase">
                        Our Latest <span className="theme-color">Blogs</span>
                      </h2>
                      <span className="section-border-bottom center"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                {blogsData?.map((data, index) => (
                  <div className="col-md-4 mb-4 isotope-item" key={index}>
                    <div className="blog-style-1 post-type post-grid" >
                      <div className="blog-inner mb-4" style={{height:"450px"}}>
                        <div className="blog-thumb relative">
                          <img
                            src={data?.image}
                            className="img-fluid"
                            style={{width:"100%", height:"auto"}}
                            alt="blog-img"
                          />
                        </div>
                        <div className="blog-details">
                          <div className="top-meta">
                            <ul className="top-meta-list d-flex">
                              <li>
                                <div className="post-date" style={{top:"30%"}}>
                                  <a>
                                    <i className="ti-calendar"></i>
                                    {formatDate(data?.date)}
                                  </a>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="blog-title">
                            <h4 className="margin-bottom-10 mt-3" style={{fontSize:"19px", lineHeight:"30px"}}>
                              <Link
                                to={`/blog/detail/${data?.slug}`}
                                className="blog-name"
                              >
                                {data?.title}
                              </Link>
                            </h4>
                          </div>
                          <div className="post-desc mt-2">
                            <div className="blog-link">
                              <Link
                                to={`/blog/detail/${data?.slug}`}
                                className="link font-w-500"
                              >
                                Read More
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        ) : (
          <div className="col-12 text-center my-5 py-5">
            <h4>No Record Available</h4>
          </div>
        )}

        <FooterWrapper />
      </div>
    </div>
  );
}

export default SecondBlogsGrid;